module.exports = __webpack_public_path__ + "img/indexBgxhs.ddcdd6fc.jpg";